import { handleApplicantIdAppend } from 'Actions/SuperAdmin/JobsAction'
import React from 'react'
import { GrLocation } from 'react-icons/gr'
import { HiOutlineBriefcase } from 'react-icons/hi2'

const SaJobApplicantsCard = ({
    candidates_card, candidate_job_role,
    applicationStatus, professionalId,
    pageRender
}) => {

    return (
        <div className="col-12 col-sm-6 col-lg-12 cursorPointer" onClick={() => handleApplicantIdAppend({ navigate: pageRender, applicant_id: professionalId })}>
            <div className="card border-0 rounded-3" id={`applicantsProfile${candidates_card?.professional_id}Card`}>
                <div className="card-body">
                    <div className="row align-items-center pt-3">
                        {/* card image  */}
                        <div className="col-4">
                            <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${candidates_card?.profile_image}`} alt="" width={83} height={83} className="rounded-circle" />
                        </div>

                        {/* card content  */}
                        <div className="col-8 px-1 pt-lg-3 pt-xl-0">
                            <div className="col-12">
                                <p className="mb-0 employer-card-candidate-name">
                                    {candidates_card?.first_name} {candidates_card?.last_name}
                                </p>

                                <div className="pt-2">
                                    <p className="mb-0 employer-card-candidate-role">
                                        <span className="pe-2"><HiOutlineBriefcase /></span>
                                        {candidates_card?.job_title}
                                    </p>
                                    <p className="mb-0 employer-card-candidate-location">
                                        <span className="pe-2"><GrLocation /></span>
                                        {candidates_card?.city}
                                    </p>
                                </div>
                            </div>
                            {
                                applicationStatus ?
                                    <div className="appliedOrSaved col-7 col-md-8 col-xl-6 p-0">
                                        <div className={`py-1 ps-3 employer-borderRadius  ${applicationStatus === "AI recommended" ?
                                            "job-shortlisted"
                                            : null ||
                                                applicationStatus === "2nd careers recommended" || applicationStatus === "recommended by second careers"
                                                ? "job-contacted"
                                                : null
                                            }`}
                                        >
                                            <p className="m-0 employer-card-absolute-fs">
                                                {applicationStatus === "2nd careers recommended" || applicationStatus === "recommended by second careers"
                                                    ? "2ndcareers-recommended"
                                                    : null ||

                                                        applicationStatus === "AI recommended"
                                                        ? "AI Recommendation"
                                                        : null}
                                            </p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SaJobApplicantsCard